function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import T from 'prop-types';
import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
// With ChatGPT's help
var FloatingScrollbar = /*#__PURE__*/ forwardRef(function(props, ref) {
    var elementId = props.elementId, children = props.children, _props_scollOffsetHeight = props.scollOffsetHeight, scollOffsetHeight = _props_scollOffsetHeight === void 0 ? 0 : _props_scollOffsetHeight, _props_thumbHeightSize = props.thumbHeightSize, thumbHeightSize = _props_thumbHeightSize === void 0 ? 100 : _props_thumbHeightSize, rest = _object_without_properties(props, [
        "elementId",
        "children",
        "scollOffsetHeight",
        "thumbHeightSize"
    ]);
    var contentRef = useRef(null);
    var thumbRef = useRef(null);
    var _useState = _sliced_to_array(useState(0), 2), thumbTop = _useState[0], setThumbTop = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), thumbHeight = _useState1[0], setThumbHeight = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isScrollable = _useState2[0], setIsScrollable = _useState2[1];
    // check if content is scrollable
    var updateScrollbar = useCallback(function() {
        var content = contentRef.current;
        var contentHeight = content === null || content === void 0 ? void 0 : content.scrollHeight;
        var containerHeight = content === null || content === void 0 ? void 0 : content.clientHeight;
        if (contentHeight > containerHeight) {
            setIsScrollable(true);
            // calculate the thumb height as a percentage of the content height
            var newThumbHeight = containerHeight / contentHeight * containerHeight * (thumbHeightSize / 100);
            setThumbHeight(newThumbHeight);
        } else {
            setIsScrollable(false);
        }
    }, [
        thumbHeightSize
    ]);
    // Observe if the content changes (e.g., window resize or content size change)
    useEffect(function() {
        var content = contentRef.current;
        var resizeObserver = new ResizeObserver(function() {
            updateScrollbar();
        });
        resizeObserver.observe(content);
        // Initial check to see if scrollbar is needed
        updateScrollbar();
        return function() {
            if (content) {
                resizeObserver.unobserve(content);
            }
        };
    }, [
        updateScrollbar
    ]);
    // Handle scrolling to move the thumb
    useEffect(function() {
        var content = contentRef.current;
        var handleScroll = function() {
            var containerHeight = content.clientHeight;
            var contentHeight = content.scrollHeight;
            var scrollFraction = content.scrollTop / (contentHeight - containerHeight);
            // Set thumb position based on scroll fraction
            setThumbTop(scrollFraction * (containerHeight - thumbHeight));
        };
        content.addEventListener('scroll', handleScroll);
        content.addEventListener('wheel', handleScroll);
        updateScrollbar();
        return function() {
            content.removeEventListener('scroll', handleScroll);
            content.removeEventListener('wheel', handleScroll);
        };
    }, [
        thumbHeight,
        updateScrollbar
    ]);
    // Handle dragging of the scrollbar thumb
    var handleMouseDown = function(e) {
        var startY = e.clientY;
        var startTop = thumbTop;
        document.body.classList.add('disable-selection');
        var onMouseMove = function(eMove) {
            var deltaY = eMove.clientY - startY;
            var newTop = startTop + deltaY;
            var containerHeight = contentRef.current.clientHeight;
            var maxThumbTop = containerHeight - thumbHeight;
            var constrainedTop = Math.max(0, Math.min(newTop, maxThumbTop));
            setThumbTop(constrainedTop);
            var scrollFraction = constrainedTop / (containerHeight - thumbHeight);
            contentRef.current.scrollTop = scrollFraction * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
        };
        var onMouseUp = function() {
            document.body.classList.remove('disable-selection');
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: "floating-scroll-container",
        id: elementId,
        ref: ref
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "content",
        ref: contentRef
    }, children), isScrollable ? /*#__PURE__*/ React.createElement("div", {
        className: "floating-scrollbar"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "floating-scroll-thumb",
        ref: thumbRef,
        style: {
            height: "".concat(thumbHeight - scollOffsetHeight, "px"),
            top: "".concat(thumbTop, "px")
        },
        onMouseDown: handleMouseDown
    })) : null);
});
FloatingScrollbar.displayName = 'FloatingScrollbar';
export default FloatingScrollbar;
FloatingScrollbar.propTypes = {
    elementId: T.string,
    children: T.node,
    scollOffsetHeight: T.number,
    thumbHeightSize: T.number
};
